import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { RuleDetailsTimeCell } from "../cells/RuleDetailsTimeCell";
import { RuleDetailsGroupCell } from "../cells/RuleDetailsGroupCell";
import { RuleDetailsStatusCell } from "../cells/RuleDetailsStatusCell";
import { RuleDetailsConditionsCell } from "../cells/RuleDetailsConditionsCell";
import { RuleDetailsActionsCell } from "../cells/RuleDetailsActionsCell";
import { RuleDetailsEditCell } from "../cells/RuleDetailsEditCell";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";

export enum RuleDetailsColumn {
    TIME = "time",
    GROUP = "group",
    STATUS = "status",
    CONDITIONS = "conditions",
    ACTIONS = "actions",
    EDIT = "edit",
}

export const historyRuleDetailsTableViewConfig: ViewConfig<
    RuleDetailsRowData,
    RuleDetailsColumn,
    never
> = {
    columns: {
        [RuleDetailsColumn.TIME]: {
            accessorKey: "logDate",
            name: "Time",
            header: "",
            cell: RuleDetailsTimeCell,
            immutable: true,
            ...DATE_COLUMN_SIZE,
        },
        [RuleDetailsColumn.GROUP]: {
            accessorKey: "groupColumn",
            name: "Group",
            header: "Group",
            cell: RuleDetailsGroupCell,
            minSize: 170,
            maxSize: 220,
        },
        [RuleDetailsColumn.STATUS]: {
            accessorKey: "statusColumn",
            name: "Status",
            header: "Status",
            cell: RuleDetailsStatusCell,
            minSize: 130,
            maxSize: 160,
        },
        [RuleDetailsColumn.CONDITIONS]: {
            accessorKey: "conditions",
            name: "Conditions",
            header: "Conditions",
            cell: RuleDetailsConditionsCell,
            minSize: 280,
            maxSize: 700,
        },
        [RuleDetailsColumn.ACTIONS]: {
            accessorKey: "actions",
            name: "Actions",
            header: "Actions",
            cell: RuleDetailsActionsCell,
            minSize: 260,
            maxSize: 700,
        },
        [RuleDetailsColumn.EDIT]: {
            accessorKey: "resource",
            name: "",
            header: "",
            cell: RuleDetailsEditCell,
            minSize: 64,
            maxSize: 80,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
